import type {
  NotificationDetailData,
  NotificationListData,
  NotificationListItem,
} from './notification-api';
import { isResidentNotificationsMockEmpty } from './is-resident-notifications-mock';

const PAGE_SIZE = 20;
const SEARCH_MIN_LENGTH = 3;

const INITIAL_MOCK_MESSAGES: NotificationListItem[] = [
  {
    id: 1,
    createdAt: '2026-06-28T14:30:00',
    subject: 'Запрос документов',
    status: 'new',
    text: 'Уважаемый резидент, пожалуйста, пришлите актуальные документы по проекту до конца недели. Это необходимо для своевременной обработки отчётности и подтверждения статуса резидента на площадке ИНТЦ.',
    managerReply: true,
  },
  {
    id: 2,
    createdAt: '2026-06-27T11:15:00',
    subject: 'Обновление шаблонов отчётов',
    status: 'read',
    text: 'В разделе «Отчёты» доступны обновлённые шаблоны для заполнения. Проверьте актуальные версии перед отправкой.',
    managerReply: true,
  },
  {
    id: 3,
    createdAt: '2026-06-26T09:40:00',
    subject: 'Подтверждение бронирования',
    status: 'new',
    text: 'По вашей заявке на бронирование переговорной комнаты сообщаем, что бронь подтверждена на 10 июля с 14:00 до 16:00.',
    managerReply: true,
  },
  {
    id: 4,
    createdAt: '2026-06-25T16:20:00',
    subject: 'Изменение расписания офиса',
    status: 'read',
    text: 'Информируем об изменении расписания работы офиса в праздничные дни. Просим учитывать это при планировании визитов.',
    managerReply: true,
  },
  {
    id: 5,
    createdAt: '2026-06-24T10:05:00',
    subject: 'Новые требования к отчётности',
    status: 'read',
    text: 'Опубликованы новые требования к отчётности резидентов. Ознакомьтесь с документом в личном кабинете.',
    managerReply: true,
  },
];

let mockMessages = cloneMockMessages(INITIAL_MOCK_MESSAGES);

function cloneMockMessages(messages: NotificationListItem[]): NotificationListItem[] {
  return JSON.parse(JSON.stringify(messages)) as NotificationListItem[];
}

function filterMessages(messages: NotificationListItem[], query: string): NotificationListItem[] {
  if (query.length < SEARCH_MIN_LENGTH) {
    return messages;
  }

  const normalized = query.toLowerCase();

  return messages.filter(
    (item) =>
      item.subject.toLowerCase().includes(normalized) ||
      item.text.toLowerCase().includes(normalized),
  );
}

function buildEmptyList(): NotificationListData {
  return {
    messages: [],
    countNewMessages: 0,
    nav: {
      totalCount: 0,
      pageSize: PAGE_SIZE,
      currentPage: 1,
      pageCount: 1,
    },
  };
}

export function resetMockNotifications(): void {
  mockMessages = cloneMockMessages(INITIAL_MOCK_MESSAGES);
}

export function getMockNotificationList(params: {
  q?: string;
  page?: number;
}): NotificationListData {
  if (isResidentNotificationsMockEmpty()) {
    return buildEmptyList();
  }

  const query = params.q?.trim() ?? '';
  const filtered = filterMessages(mockMessages, query);
  const page = Math.max(1, params.page ?? 1);
  const totalCount = filtered.length;
  const pageCount = Math.max(1, Math.ceil(totalCount / PAGE_SIZE));
  const currentPage = Math.min(page, pageCount);
  const offset = (currentPage - 1) * PAGE_SIZE;

  return {
    messages: filtered.slice(offset, offset + PAGE_SIZE),
    countNewMessages: mockMessages.filter((item) => item.status === 'new').length,
    nav: {
      totalCount,
      pageSize: PAGE_SIZE,
      currentPage,
      pageCount,
    },
  };
}

export function getMockNotificationDetail(id: number): NotificationDetailData {
  const message = mockMessages.find((item) => item.id === id);

  if (!message) {
    throw new Error('Уведомление не найдено');
  }

  return {
    id: message.id,
    createdAt: message.createdAt,
    subject: message.subject,
    message: `<p>${message.text}</p>`,
    status: message.status,
    files: [],
    from: 'manager@intc.ru',
    to: 'ООО «Резидент»',
  };
}

export function markMockNotificationRead(id: number): string {
  const message = mockMessages.find((item) => item.id === id);

  if (message) {
    message.status = 'read';
  }

  return 'Уведомление отмечено как прочитанное';
}

export function replyToMockNotification(): string {
  return 'Ваш ответ отправлен';
}
